<template>
  <div>
    <div class="d-flex align-items-center">
      <div
        class="d-flex align-items-center"
        v-for="item in items" :key="item.name">
        <div :class="s.datetime_wrap">
          <select
            v-if="item.type === 'select'"
            :name="item.name"
            :id="item.name"
            :class="s[item.name]"
            class="form-control"
            @change="updateValue(item.name, $event)">
            <option
              v-for="opt in getOptions(item.name)"
              :key="opt.value"
              :value="opt.value"
              :selected="date[item.name] === opt.value">{{ opt.label }}</option>
          </select>
          <span
            :class="s.suffix"
            v-if="item.form_suffix">{{ item.form_suffix }}</span>
        </div>
      </div>
      <div v-if="showAge">
        <span class="ms-3" v-if="calcAge">{{ calcAge }}歳</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'date-selector',
  props: {
    showAge: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      date: {
        year: null,
        month: null,
        day: null,
      },
      items: [
        {
          name: 'year',
          type: 'select',
          form_suffix: '年',
          prefix: '-',
        },
        {
          name: 'month',
          type: 'select',
          form_suffix: '月',
          prefix: '-',
        },
        {
          name: 'day',
          type: 'select',
          form_suffix: '日',
          prefix: '-',
        },
      ],
    };
  },
  computed: {
    days() {
      let days = [];

      if ((this.date?.month === 2 && this.date?.year % 4 === 0 && this.date?.year % 100 !== 0) || (this.date?.month === 2 && this.date?.year % 400 === 0)) {
        days = [...Array(29)].map((ele, i) => i + 1);
      } else if (this.date?.month === 2) {
        days = [...Array(28)].map((ele, i) => i + 1);
      } else if (this.date?.month === 4 || this.date?.month === 6 || this.date?.month === 9 || this.date?.month === 11) {
        days = [...Array(30)].map((ele, i) => i + 1);
      } else {
        days = [...Array(31)].map((ele, i) => i + 1);
      }
      days = ['--', ...days];
      return this.adjustDate(days);
    },
    calcAge() {
      const birthDate = this.date;
      if (!birthDate.year || !birthDate.month || !birthDate.day) return null;

      // 現在の日付を取得
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1; // JavaScriptの月は0から始まるため+1する
      const currentDay = currentDate.getDate();

      // 生年月日から年齢を計算
      let age = currentYear - birthDate.year;

      // まだ誕生日が来ていない場合は年齢から1を引く
      if (birthDate.month > currentMonth || (birthDate.month === currentMonth && birthDate.day > currentDay)) {
        age -= 1;
      }

      return age;
    },
  },
  methods: {
    years() {
      const years = ['----'];
      for (let year = 1920; year <= new Date().getFullYear(); year += 1) {
        years.push(year);
      }
      return this.adjustDate(years);
    },
    months() {
      const months = ['--', ...[...Array(12)].map((ele, i) => i + 1)];
      return this.adjustDate(months);
    },
    adjustDate(array) {
      return array.map((ele) => { // eslint-disable-line
        return { label: !['----', '--'].includes(ele) && ele < 10 ? `0${ele}` : ele, value: ['----', '--'].includes(ele) ? null : ele };
      });
    },
    getOptions(name) {
      if (name === 'year') {
        return this.years();
      }
      if (name === 'month') {
        return this.months();
      }
      if (name === 'day') {
        return this.days;
      }
      return [];
    },
    updateValue(name, event) {
      this.date[name] = Number(event.target.value);
      if ((name === 'year' || name === 'month') && !this.days.map((d) => d.value).includes(this.date.day)) {
        // 月や年が変更された時、存在しない日だったら変更
        this.date.day = this.days[this.days.length - 1].value;
      }
      if (this.date.year && this.date.month && this.date.day) {
        this.$emit('input', `${this.date.year}-${this.paddingZero(this.date.month)}-${this.paddingZero(this.date.day)}`);
      } else {
        this.$emit('input', '');
      }
    },
    paddingZero(num) {
      return num < 10 ? `0${num}` : num;
    },
  },
};
</script>

<style lang="scss" module="s">
.year {
  width: 5em;
  border-radius: .25rem 0 0 0;
}
.month, .day {
  width: 4em;
  margin-left: -1px;
  border-radius: 0;
}

.datetime_wrap {
  position: relative;
  input, select {
    padding-right: 24px;
  }
  .suffix {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
  }
}
</style>
